import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { useAtom } from "jotai";
import { useHistory } from "react-router-dom";
import Button from "../ButtonUI";

import { colorAvatar, tabsR } from "./fakeData";
import { statusLabel } from "../../helper/demandeStatus";
import moment from "../../helper/moment";
import { userAtom } from "../../state/auth";
import { refreshAtom } from "../../state/refreshPatientInfo";
import { User } from "../../types/user";

import Spinner from "../Spinner";
import AddRequestModal from "./modal/AddRequestTelex";
import SharedRequest from "../SharedRequest";
import AddPatient from "../../pages/MyPatients/addPatient";

import telex from "../../assets/images/dermatologista.png";
import birthday from "../../assets/images/birthday.png";
import phone from "../../assets/images/phone.png";
import mail from "../../assets/images/mail.png";
import home from "../../assets/images/home.png";
import { ReactComponent as WomanPatient } from "../../assets/illustrations/illustration-femme-patienta.svg";
import { ReactComponent as ManPatient } from "../../assets/illustrations/illustration-homme-patienta.svg";
import { ReactComponent as Close } from "../../assets/icons/icon-close.svg";
import ConfirmationModal from "../ConfirmationModal";
import { resetPatientAccess } from "../../api/medecin";
import makeToast from "../Snackbar";
interface IProps {
  openModal: Boolean;
  setOpenModal: Function;
  updatePatientData: Function;
  message?: String;
  type?: String;
  url?: string;
  patientData?: any;
  antecedentsList?: [] | any;
  antecedentsChrirugicalList?: [] | any;
  setDocumentsList?: [] | any;
  documentsList?: [] | any;
  consultaionPage?: boolean;
  colorIndex?: number;
  setPatientAdded: Function;
  setSelectedPatient: Function;
  setPatientData: Function;
  setOpenModalInfoPatient: Function;
}

const PatientInfo: React.FC<IProps> = ({
  patientData,
  setOpenModal,
  consultaionPage,
  colorIndex,
  updatePatientData,
  setPatientAdded,
  setSelectedPatient,
  setPatientData,
  setOpenModalInfoPatient,
}) => {
  const [constId, setConstId] = useState("69ce7ee7d718b7b424e9a893");
  const [openTab, setOpenTab] = useState(1);
  const [modalAdd, setModalAdd] = useState(false);
  const [modalRequest, setModalRequest] = useState(false);
  const [accountResetModalIsOpen, setAccountResetModalIsOpen] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState<any>();
  const [display, setDisplay] = useState(true);
  const [user] = useAtom<User | any>(userAtom);
  const [refreshPatientInfo] = useAtom(refreshAtom);
  const [tabs, setTabs] = useState(tabsR);
  const [editMode, setEditMode] = useState(false);
  const colorStatus = (status, delai) => {
    switch (status) {
      case "IN_PROGRESS":
        if (moment(delai).diff(moment(), "hours") > 1) {
          return "rgba(52, 211, 153)";
        } else {
          return "rgb(244 ,142 ,154)";
        }

      case "RESPONSE":
        return "rgba(52, 211, 153)";
      default:
        if (moment(delai).diff(moment(), "hours") > 1) {
          return "rgba(98 145 240)";
        } else {
          return "rgb(244 ,142 ,154)";
        }
    }
  };
  useEffect(() => {}, [openTab, refreshPatientInfo?.state]);
  //fixed inset-0 z-50 bg-white overflow-y-auto md:inset-auto md:static md:bg-transparent md:overflow-visible //old css
  //fixed inset-0 z-50 outline-none focus:outline-none overflow-x-hidden overflow-y-auto bg-opacity-modal flexCenter // will display suivant maybe
  // inset-0 z-50 outline-none focus:outline-none overflow-hidden bg-opacity-modal flex justify-center md:justify-end
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 50, backgroundColor: "rgba(0, 0, 0, 0.5)", overflow: "hidden" }}> 
    <div style={{ position: "absolute", top: 0, right: 0, bottom: 0, zIndex: 50, height: "100%", width: "100%", maxWidth: "641px", overflowY: "auto", backgroundColor: "white" }}> 
      {patientData?._id ? (
        <div className="
          absolute inset-y-0 right-0 z-40 patient-modal-info md:left-auto md:w-[641px] md:rounded-[20px] left-0 h-full
        ">
          <div
            className={`sub-container ${display ? "overflow-hidden" : "max-h-content"}`}
          >
            <div className="flex flex-col w-full bg-white rounded-t-2xl">
              <div className="flex p-4 items-start">
                <div
                  className="photo flex-shrink-0 w-16 h-16 sm:w-20 sm:h-20 rounded-full flexCenter shadow-sm"
                  style={{
                    backgroundColor:
                      colorAvatar[(colorIndex || 1) % colorAvatar.length],
                  }}
                >
                  {patientData?.gender === "male" ? (
                    <ManPatient />
                  ) : (
                    <WomanPatient />
                  )}
                </div>

                <div className="flex-1 min-w-0 ml-4">
                  <div className="mb-3">
                    <p className="font-bold text-xl capitalize text-gray-800 break-words leading-tight">
                      {patientData.firstName} {patientData.lastName}
                    </p>
                    <div className="flex items-center mt-1 text-gray-500">
                      <img
                        src={birthday}
                        alt="birthday"
                        className="w-4 h-4 flex-shrink-0"
                      />
                      <p className="ml-2 text-sm font-medium">
                        {moment(patientData.birthday).format("L")} (
                        {moment().diff(patientData.birthday, "years")} ans)
                      </p>
                    </div>
                  </div>

                  <div className="space-y-2">
                    <div className="flex items-center text-gray-600">
                      <img
                        src={phone}
                        alt="phone"
                        className="w-3.5 h-3.5 mr-3 flex-shrink-0 opacity-70"
                      />
                      <span className="text-sm truncate">
                        {patientData.phone}
                      </span>
                    </div>

                    <div className="flex items-start text-gray-600">
                      <img
                        src={mail}
                        alt="mail"
                        className="w-3.5 h-3.5 mr-3 mt-1 flex-shrink-0 opacity-70"
                      />
                      <span className="text-sm break-all leading-tight">
                        {patientData.email || "N/A"}
                      </span>
                    </div>

                    <div className="flex items-start text-gray-600">
                      <img
                        src={home}
                        alt="home"
                        className="w-3.5 h-3.5 mr-3 mt-1 flex-shrink-0 opacity-70"
                      />
                      <span className="text-sm break-words leading-tight">
                        {patientData.adresse || "N/A"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-between border-t border-gray-100 p-3 mt-2 bg-gray-50/50 rounded-b-2xl">
                <div className="flex gap-2">
                  <button
                    type="button"
                    className="flex items-center justify-center gap-2 px-4 h-10 bg-white border border-gray-200 rounded-xl shadow-sm hover:bg-blue-50 transition-colors group"
                    onClick={() => setEditMode(true)}
                  >
                    <img
                      src={
                        require(`../../assets/images/pen.png`).default ||
                        require(`../../assets/images/pen.png`)
                      }
                      alt="edit"
                      className="w-4 h-4 opacity-70 group-hover:opacity-100"
                    />
                    <span className="text-xs font-bold text-gray-600 group-hover:text-blue-600 uppercase">
                      Modifier
                    </span>
                  </button>
                </div>

                {!consultaionPage && (
                  <div className="flex gap-2">
                    <button
                      type="button"
                      onClick={() => setOpenModal(false)}
                      className="flex items-center justify-center px-4 h-10 bg-white border border-gray-200 rounded-xl shadow-sm hover:bg-gray-200"
                    >
                      <span className="w-4 h-4 flex items-center justify-center text-sm font-bold">
                        ×
                      </span>
                      <span className="text-xs font-bold uppercase tracking-wider">
                        Fermer
                      </span>
                    </button>
                  </div>
                )}
              </div>
            </div>

            {user.type === "medecinResponsable" && patientData.hasAccount ? (
              <>
                <div className="my-3 w-full flex justify-center">
                  <Button
                    status="secondary"
                    className="px-8"
                    height={"35px"}
                    onClick={() => {
                      setAccountResetModalIsOpen(true);
                    }}
                  >
                    Renvoyer email d'accès
                  </Button>
                </div>
                <ConfirmationModal
                  isOpen={accountResetModalIsOpen}
                  onClose={() => {
                    setAccountResetModalIsOpen(false);
                  }}
                  onConfirm={() => {
                    resetPatientAccess(patientData._id)
                      .then(() => {
                        makeToast(
                          "success",
                          "Les accès ont été envoyés au patient avec succès.",
                        );
                      })
                      .catch((error) => {
                        console.error(error);
                        makeToast(
                          "error",
                          "Une erreur est survenue lors de l'envoi des accès au patient.",
                        );
                      });
                  }}
                >
                  Êtes-vous sûr de vouloir réinitialiser les accès de ce patient
                  et lui renvoyer un email avec les instructions nécessaires
                  pour son inscription ?
                </ConfirmationModal>
              </>
            ) : null}

            <div className={`patient-tabs ${!display ? "stretch" : null}`}>
              <div className="tabs flex items-center justify-between	">
                {tabs.map((tab) => {
                  return (
                    <div
                      className={
                        openTab === tab.id
                          ? "tab selected flexCenter"
                          : "tab flexCenter cursor-pointer"
                      }
                      onClick={() => {
                        setOpenTab(tab.id);
                        if (tab.id === 0 || tab.id === 3) {
                          setDisplay(true);
                        } else if (tab.id === 1 || tab.id === 2) {
                          setDisplay(true);
                        }
                      }}
                    >
                      {tab.name}
                    </div>
                  );
                })}
              </div>
              <div></div>
            </div>
            <div className="relative tabs-content">
              {openTab !== 3 ? (
                <div></div>
              ) : openTab === 3 ? undefined : (
                <div></div>
              )}
              <div className="tabs-container">
                <div className="tab-content tab-space tabs-liste">
                  <div
                    className={classNames(
                      "item",
                      openTab === 0 ? "block" : "hidden",
                    )}
                    id=""
                  >
                    <div className="sub-item">
                      <div className="title-container">
                        <p className="title">Actions Rapide Patient</p>
                        <span className="card-subtitle">
                          Inscrit depuis :{" "}
                          {moment(patientData.createdAt).format("L")}
                        </span>
                      </div>
                      <div className="flex values-patient">
                        <div className="flexCenter sub-values"></div>
                        <div className="flexCenter sub-values"></div>
                      </div>
                    </div>
                  </div>
                  <div className={openTab === 1 ? "block" : "hidden"} id="">
                    <div className="flex flex-col">
                      {user.type !== "medecinResponsable" && (
                        <div className="my-3">
                          <Button
                            status="secondary"
                            className=""
                            width={"146px"}
                            height={"35px"}
                            onClick={() => {
                              setModalAdd(true);
                            }}
                          >
                            Téléexpertise
                          </Button>
                        </div>
                      )}

                      {user.type === "medecin" ? (
                        <>
                          <ul className="flex flex-col ">
                            {patientData.demandes.filter(function (e) {
                              return (
                                e.docReq === user._id ||
                                patientData?.authorizedDoctors?.includes(
                                  user._id,
                                )
                              );
                            }).length > 0 ? (
                              <>
                                {patientData.demandes
                                  .filter(function (e) {
                                    return (
                                      (e.docReq === user._id ||
                                        patientData?.authorizedDoctors?.includes(
                                          user._id,
                                        )) &&
                                      !e.isDeleted
                                    );
                                  })
                                  .reverse()
                                  .map((d) => (
                                    <div
                                      className="card-specialist  p-3 space-x-3 max-w-max shadow relative"
                                      onClick={() => {
                                        setSelectedRequest(d);
                                        setModalRequest(true);
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <span
                                        className={`rounded-full w-3 h-3 absolute right-1 top-2 m-2 `}
                                        style={{
                                          backgroundColor: colorStatus(
                                            d.status,
                                            d.delaiDate,
                                          ),
                                        }}
                                      ></span>
                                      <div className="flex flex-col sm:flex-row">
                                        <div
                                          className="rounded-lg h-10 w-10 sm:h-14 sm:w-14 flexCenter ml-2 mr-3 sm:mx-5 my-auto shrink-0"
                                          style={{
                                            backgroundColor: colorAvatar[Math.floor(Math.random() * colorAvatar.length)],
                                            opacity: 0.7,
                                          }}
                                        >
                                          <img
                                            src={telex}
                                            alt="telex"
                                            className="w-8 h-8 sm:w-[45px] sm:h-[45px] object-contain"
                                          />
                                        </div>
                                        <div className="details relative pr-6">
                                          <div className="flex-grow">
                                            <p className="card-title">
                                              Demande de téléexpertise en
                                              {" " + d.specialite}
                                            </p>
                                            <p className="font-bold text-gray-700">
                                              {" "}
                                              Type :{" " + d.type}
                                            </p>
                                            <p className=" mt-1 + break-words font-bold text-sm    ">
                                              {statusLabel(
                                                d.status,
                                                d.delaiDate,
                                                user?.type,
                                                d.priseEncharge,
                                              )}
                                            </p>
                                            
                                            <p className="card-sub-title text-xs sm:text-xs mt-2 text-right whitespace-nowrap">
                                              {" le "}
                                              {moment(d.createdAt).format(
                                                "LL à HH:mm",
                                              )}
                                            </p>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="flex space-x-3"></div>
                                    </div>
                                  ))}
                              </>
                            ) : (
                              <div className="flexCenter w-full anEmptyBox">
                                <p className="card-subtitle">
                                  Ce patient n'a aucune demande de
                                  téléexpertise.
                                </p>
                              </div>
                            )}
                          </ul>
                        </>
                      ) : (
                        <div className="container flex flex-col mx-auto w-full  ">
                          <ul className="flex flex-col">
                            {patientData.demandes.length > 0 ? (
                              <>
                                {patientData.demandes
                                  .filter(function (e) {
                                    return !e.isDeleted;
                                  })
                                  .reverse()
                                  .map((d) => (
                                    <div
                                      className="card-specialist p-3 w-full sm:w-auto shadow relative"
                                      onClick={() => {
                                        setSelectedRequest(d);
                                        setModalRequest(true);
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <div className="flex">
                                        <div
                                          className="rounded-lg h-14 w-14 flexCenter mx-5 my-auto"
                                          style={{
                                            backgroundColor:
                                              colorAvatar[
                                                Math.floor(
                                                  Math.random() *
                                                    colorAvatar.length,
                                                )
                                              ],
                                            opacity: 0.7,
                                          }}
                                        >
                                          {d.type ===
                                          "Dermatose non tumorale" ? (
                                            <img
                                              src={telex}
                                              alt="telex"
                                              width={"45px"}
                                              height={"45px"}
                                            />
                                          ) : (
                                            <img
                                              src={telex}
                                              alt="telex"
                                              width={"45px"}
                                              height={"45px"}
                                            />
                                          )}
                                        </div>
                                        <div className="details flex-1 min-w-0">
                                          <div className="flex-grow">
                                            <p className="card-title break-words whitespace-normal">
                                              Demande de téléexpertise en
                                              {" " + d.specialite}
                                            </p>
                                            <p className="font-bold text-gray-700">
                                              {" "}
                                              Type :{" " + d.type}
                                            </p>
                                            <p className=" mt-1 + break-words font-bold text-sm    ">
                                              {statusLabel(
                                                d.status,
                                                d.delaiDate,
                                                user?.type,
                                                d.priseEncharge,
                                              )}
                                            </p>
                                            <div className="absolute top-2 right-2 flex items-center space-x-2">
                                              {user?.type ===
                                                "medecinResponsable" && (
                                                <span
                                                  className={`px-2 py-0.5 text-xs font-semibold rounded-full ${
                                                    d?.isDeleted
                                                      ? "bg-red-100 text-red-700"
                                                      : "bg-green-100 text-green-700"
                                                  }`}
                                                >
                                                  {d?.isDeleted
                                                    ? "Masquée"
                                                    : "Visible"}
                                                </span>
                                              )}

                                              <span
                                                className="rounded-full w-3 h-3"
                                                style={{
                                                  backgroundColor: colorStatus(
                                                    d.status,
                                                    d.delaiDate,
                                                  ),
                                                }}
                                              ></span>
                                            </div>

                                            <p className="card-sub-title text-[10px] sm:text-xs whitespace-nowrap">
                                              {" le "}
                                              {moment(d.createdAt).format(
                                                "LL à HH:mm",
                                              )}
                                            </p>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="flex space-x-3"></div>
                                    </div>
                                  ))}
                              </>
                            ) : (
                              <div className="flexCenter w-full anEmptyBox">
                                <p className="card-subtitle">
                                  Ce patient n'a aucune demande de
                                  téléexpertise.
                                </p>
                              </div>
                            )}
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className={openTab === 5 ? "block" : "hidden"} id="">
                    <div className="flexCenter w-full anEmptyBox">
                      <p className="card-subtitle">
                        Ce patient n'a aucun historique.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="absolute  inset-y-0 right-0 z-40  transition ease-in duration-700 patient-modal-info">
          <Spinner />
        </div>
      )}

      {modalAdd && (
        <AddRequestModal
          patientId={patientData._id}
          openModal={modalAdd}
          constId={constId}
          setPatientAdded={setPatientAdded}
          setOpenModal={setModalAdd}
          gender={patientData.gender}
        />
      )}
      {editMode && (
        <AddPatient
          editMode={true}
          openModal={editMode}
          setOpenModal={setEditMode}
          setPatientAdded={setPatientAdded}
          setSelectedPatient={setSelectedPatient}
          setPatientData={setPatientData}
          patientData={patientData}
          setOpenModalInfoPatient={() => console.log("")}
        />
      )}
      {modalRequest && (
        <SharedRequest
          demandeData={selectedRequest}
          setOpenModal={setModalRequest}
          colorIndex={0}
          consultaionPage={false}
        />
      )}
    </div>
    </div>
  );
};

export default PatientInfo;
